export default __webpack_public_path__ + "static/TTCommons-Medium-8e7d7a3962646adbad25ae38905c6009.woff";